// removed by extract-text-webpack-plugin
module.exports = {"root":"PasswordChangeForm__root__O-F72","newPasswordSection":"PasswordChangeForm__newPasswordSection__2JLb0","confirmChangesSection":"PasswordChangeForm__confirmChangesSection__2jFfW","confirmChangesSectionVisible":"PasswordChangeForm__confirmChangesSectionVisible__28V3R","confirmChangesTitle":"PasswordChangeForm__confirmChangesTitle__3cI0r","confirmChangesInfo":"PasswordChangeForm__confirmChangesInfo__3egLw","bottomWrapper":"PasswordChangeForm__bottomWrapper__1f2rA","error":"PasswordChangeForm__error__1454M"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/PasswordChangeForm/PasswordChangeForm.css
// module id = 1724
// module chunks = 0